import React, { createContext, useContext, useState, useEffect } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { StorageWrapper } from '../../../utils/storage.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
const UIGameFullScreenContext = /*#__PURE__*/ createContext(undefined);
export const useUIGameFullScreenContext = ()=>{
    const context = useContext(UIGameFullScreenContext);
    if (!context) throw new Error('useUIGameFullScreenContext must be used within a UIGameFullScreenContext');
    return context;
};
export const UIGameFullScreenProvider = ({ children })=>{
    const [isFullScreen, setIsFullScreen] = useState(!!document.fullscreenElement);
    const requestFullScreenPermission = useGameStore((state)=>state.gameClientConfig.requestFullScreenPermission);
    const sendFullScreenMembershipAnalytics = useGameStore((state)=>state.gameAnalytics.sendFullScreenMembershipAnalytics);
    useEffect(()=>{
        const onFullScreenChange = ()=>{
            setIsFullScreen(!!document.fullscreenElement);
        };
        document.addEventListener('fullscreenchange', onFullScreenChange);
        return ()=>{
            document.removeEventListener('fullscreenchange', onFullScreenChange);
        };
    }, []);
    useHotkeys('f', ()=>{
        if (!StorageWrapper.getKeyboardShortcuts()) return;
        toggleFullScreen();
    });
    const requestFullScreen = ()=>{
        sendFullScreenMembershipAnalytics();
        const canEnableFullScreen = requestFullScreenPermission();
        if (!canEnableFullScreen) return;
        void document.documentElement.requestFullscreen();
    };
    const exitFullScreen = ()=>{
        sendFullScreenMembershipAnalytics();
        void document.exitFullscreen();
    };
    const toggleFullScreen = ()=>{
        if (isFullScreen) {
            exitFullScreen();
        } else {
            requestFullScreen();
        }
    };
    return /*#__PURE__*/ React.createElement(UIGameFullScreenContext.Provider, {
        value: {
            isFullScreen: isFullScreen,
            toggleFullScreen: toggleFullScreen
        }
    }, children);
};
